import styled from 'styled-components'

export const Icon = styled.i`
    font-style: normal;
    font-weight: 900;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme['gray-600']};
    transition-duration: 0.5s;
`
export const DropDownIndicator = styled.i`
    position: relative;
    font-style: normal;
    font-weight: 900;
    font-size: 11px;
    line-height: 16px;
    color: ${({ theme }) => theme['gray-600']};
    transition-duration: 0.5s;
    padding-left: 2px;
`

export const DropdownContainer = styled.section`
    display: block;
    position: absolute;
    margin-top: 20px;
    visibility: hidden;
    opacity: 0.9;
    transition: 0.1s;
`

export const ContainerButton = styled.section`
    display: flex;
    overflow: hidden;
    justify-content: center;
    flex-direction: row;
    padding: 5px;
    transition-duration: 1s;
    z-index: 14;
    &:hover {
        ${DropdownContainer} {
            visibility: visible;
            margin-top: 23px;
            transition: 0.3s;
            opacity: 1;
        }
    }
    &:focus-within {
        ${Icon} {
            color: ${({ theme }) => theme['gray-800']};
        }
        ${DropDownIndicator} {
            color: ${({ theme }) => theme['gray-800']};
        }
    }
`

export const ButtonArea = styled.button`
    display: flex;
    flex-direction: row;
    background-color: ${({ theme }) => theme['gray-0']};
    border: none;
    color: white;
    text-align: center;
    text-decoration: none;
    font-size: 16px;
    transition-duration: 1s;
    height: max-content;
    &:hover {
        ${Icon} {
            color: ${({ theme }) => theme['gray-800']};
        }
        ${DropDownIndicator} {
            color: ${({ theme }) => theme['gray-800']};
        }
    }
`
